import styled from '@emotion/styled'
import { isMobile } from '@const/device'

export const TableWrapper = styled.div`
  max-width: 100vw;
  overflow-y: auto;
  padding: ${() => (isMobile ? '0 5px' : '0 20px')};
`
